import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";
import { useSimilarAnswersContext } from "./SimilarAnswersContext";

// The initial state shown when suggestions exist and the user has not yet acted.
// Offers to open the review funnel (via onOpenFunnel) or dismiss suggestions entirely.
const SimilarAnswersSuggestionsPrompt = ({ onOpenFunnel }) => {
  const { contributionIds, dismissSuggestions } = useSimilarAnswersContext();

  const t = useFormatMessage();
  const count = contributionIds.length;
  const suggestionTitle = t(intlMessages.suggestionTitle, { count });
  const suggestionDescription = t(intlMessages.suggestionDescription);
  const reviewLabel = t(intlMessages.reviewSuggestions);
  const dismissLabel = t(intlMessages.dismissSuggestions);

  return (
    <>
      <h2 className="text-primary text-subtitle-section margin-bottom-xs">
        {suggestionTitle}
      </h2>

      <p className="text-small text-muted margin-bottom-xs">{suggestionDescription}</p>

      <div className="d-flex justify-content-end">
        <Button
          type="button"
          className="btn btn-primary btn-sm order-1"
          onClick={onOpenFunnel}
          label={reviewLabel}
        />

        <Button
          type="button"
          className="btn btn-primary-inverse btn-sm margin-left-xs"
          onClick={dismissSuggestions}
          label={dismissLabel}
        />
      </div>
    </>
  );
};

export default SimilarAnswersSuggestionsPrompt;

const intlMessages = defineMessages({
  suggestionTitle: {
    id: "similarAnswers.suggestionTitle",
    defaultMessage:
      "{count, plural, one {# contribution en rapport trouvée} other {# contributions en rapport trouvées}}"
  },
  suggestionDescription: {
    id: "similarAnswers.suggestionDescription",
    defaultMessage: `D'autres contributions traitent du même sujet, donnez votre avis 
      dessus !`
  },
  reviewSuggestions: {
    id: "similarAnswers.reviewSuggestions",
    defaultMessage: "Consulter les suggestions"
  },
  dismissSuggestions: {
    id: "similarAnswers.dismissSuggestions",
    defaultMessage: "Ignorer"
  }
});
